export default "__VITE_ASSET__e0000285__"